<div class="promo-t3-page">
    <!-- =========================================
         ENCABEZADO
    ========================================== -->
    <section class="promo-t3-header">
        <span class="promo-t3-eyebrow">
            PROMOCIÓN
        </span>
        <h1 class="promo-t3-title">
            {{ stepOne ? 'Elige tu producto' : 'Elige tu regalo' }}
        </h1>
        <p class="promo-t3-subtitle">
            {{ promo }}
        </p>
    </section>
    <!-- =========================================
         CONTENIDO
    ========================================== -->
    <section class="promo-t3-content">
        <!-- =====================================
             PRODUCTOS - PASO 1
        ====================================== -->
        <div class="promo-t3-products" *ngIf="stepOne && products.length > 0">
            <article class="promo-t3-card" [class.selected]="product.selected" *ngFor="let product of products"
                (click)="selectedProduct(product)">
                <div class="promo-t3-image">
                    <img [src]="product.urlFoto" [defaultImage]="defImgProd"
                        [alt]="product.productoAgrupador || product.producto">
                </div>
                <div class="promo-t3-card-content">
                    <div class="promo-t3-product-info">
                        <h3>
                            {{ product.producto }}
                        </h3>
                        <p class="promo-t3-price">
                            {{ product.precioVenta | currency:'USD':'symbol':'1.0-0' }}
                        </p>
                    </div>
                    <div class="promo-t3-check" *ngIf="product.selected">
                        <mat-icon>
                            check_circle
                        </mat-icon>
                    </div>
                </div>
            </article>
        </div>


        <!-- =====================================
             REGALOS - PASO 2
        ====================================== -->
        <div class="promo-t3-products" *ngIf="stepTwo && gifts.length > 0">
            <article class="promo-t3-card" [class.selected]="gift.selected" *ngFor="let gift of gifts"
                (click)="selectedProductGift(gift)">
                <div class="promo-t3-image">
                    <img [src]="gift.urlFoto" [defaultImage]="defImgProd"
                        [alt]="gift.productoAgrupador || gift.producto">
                </div>
                <div class="promo-t3-card-content">
                    <div class="promo-t3-product-info">
                        <h3>
                            {{ gift.producto }}
                        </h3>
                        <p class="promo-t3-price">
                            {{ gift.precioNormal | currency:'USD':'symbol':'1.0-0' }}
                        </p>
                    </div>
                    <div class="promo-t3-check" *ngIf="gift.selected">
                        <mat-icon>
                            check_circle
                        </mat-icon>
                    </div>
                </div>
            </article>
        </div>
        <!-- =====================================
             PANEL DE ACCIÓN
        ====================================== -->
        <aside class="promo-t3-panel">
            <div class="promo-t3-panel-content">
                <span class="promo-t3-panel-eyebrow">
                    {{ stepOne ? 'PASO 1 DE 2' : 'PASO 2 DE 2' }}
                </span>
                <h2>
                    {{ stepOne
                    ? 'Selecciona tu producto'
                    : 'Selecciona tu regalo'
                    }}
                </h2>
                <p>
                    {{ stepOne
                    ? 'Elige el producto que deseas adquirir para continuar con la promoción.'
                    : 'Ahora elige el producto que quieres recibir como regalo.'
                    }}
                </p>
                <!-- PASO 1 -->
                <button *ngIf="stepOne" class="promo-t3-button" mat-raised-button type="button" (click)="continuar()"
                    [disabled]="selectedProductData === null">
                    CONTINUAR
                </button>
                <!-- PASO 2 -->
                <button *ngIf="stepTwo" class="promo-t3-button" mat-raised-button type="button" (click)="finalizar()"
                    [disabled]="selectedProductGiftData === null || btnDisabled">
                    SELECCIONAR
                </button>
            </div>
        </aside>
    </section>
</div>